/**
 * Objeto centralizado com todas as rotas da aplicação
 * Use este arquivo para manter consistência nas rotas em toda a aplicação
 */

export const routes = {
  // Rotas privadas
  index: '/',
  home: '/home',
  usuarios: '/usuarios',
  analisar: '/analisar',
  visao_mercado: '/visao-mercado',
  central_reajuste: '/central-reajuste',
  comparar_escolas: '/comparar-escolas',
  escolas_enem: '/escolas-enem',
  completar_cadastro: '/completar-cadastro',

  // Rotas públicas
  politica_de_privacidade: '/politica-de-privacidade',

  // Rotas de autenticação
  auth: {
    login: '/auth/login',
    tenant_select: '/auth/tenant-select',
    verify_email: '/auth/verify-email',
  },

  // Rotas demonstrativas do boilerplate
  typography: '/typography',
  button: '/button',
  kanban: '/kanban',
  forms: '/forms',
  notifications: '/notifications',
  tests: '/tests',
  datagrid: '/datagrid',

  // Rotas de configurações
  users: '/users',
  invites: '/invites',
} as const;

// Tipo para autocompletar as rotas
export type Route =
  | (typeof routes)[keyof typeof routes]
  | (typeof routes.auth)[keyof typeof routes.auth];

// Helper para obter rotas de autenticação
export const getAuthRoute = (route: keyof typeof routes.auth): string => {
  return routes.auth[route];
};

// Helper para obter rotas principais
export const getRoute = (route: keyof Omit<typeof routes, 'auth'>): string => {
  return routes[route];
};

// Helper para obter rota de análise de escola
export const getAnalisarEscolaRoute = (codigoEscola: string): string => {
  return `${routes.analisar}/${codigoEscola}`;
};

const baseUrl = 'https://www.lumnieducacao.com.br';

export const siteLumniEducaoRoutes = {
  blog: `${baseUrl}/blog`,
  ferramentas: `${baseUrl}/ferramentas/`,
  ferramentas_ia_gerador_blog: `${baseUrl}/ferramentas/inteligencia-artificial/gerador-blog/`,
  ferramentas_ia_copies_anuncios: `${baseUrl}/ferramentas/inteligencia-artificial/gerador-copy-anuncio/`,
  ferramentas_ia_discursos_captacao: `${baseUrl}/ferramentas/inteligencia-artificial/gerador-discurso-captacao/`,
  ferramentas_ia_legendas_instagram: `${baseUrl}/ferramentas/inteligencia-artificial/gerador-legenda-instagram/`,
  ferramentas_ia_reescrever_textos: `${baseUrl}/ferramentas/inteligencia-artificial/reescrever-textos/`,
} as const;
